import React, { ComponentProps, FunctionComponent } from "react";

const QuestionMarkIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      fill: "currentColor",
      fillRule: "evenOdd",
      clipRule: "evenOdd",
      d: "M15.5456 8.68196C15.5456 4.38917 12.0656 0.90918 7.77278 0.90918C3.47999 0.90918 0 4.38917 0 8.68196C0 4.38983 3.47987 0.90918 7.77278 0.90918C12.0657 0.90918 15.5456 4.38983 15.5456 8.68196ZM1.29572 8.68196C1.29572 5.11037 4.20119 2.2049 7.77278 2.2049C11.3444 2.2049 14.2498 5.11037 14.2498 8.68196C14.2498 12.2536 11.3444 15.159 7.77278 15.159C4.20119 15.159 1.29572 12.2536 1.29572 8.68196ZM8.55006 12.1797C8.55006 11.9736 8.46817 11.7759 8.3224 11.6301C8.17663 11.4843 7.97893 11.4024 7.77278 11.4024C7.56664 11.4024 7.36893 11.4843 7.22316 11.6301C7.0774 11.7759 6.9955 11.9736 6.9955 12.1797C6.9955 12.3859 7.0774 12.5836 7.22316 12.7293C7.36893 12.8751 7.56664 12.957 7.77278 12.957C7.97893 12.957 8.17663 12.8751 8.3224 12.7293C8.46817 12.5836 8.55006 12.3859 8.55006 12.1797ZM9.28423 5.22731C8.88337 4.82645 8.33969 4.60125 7.77278 4.60125C7.20588 4.60125 6.66219 4.82645 6.26133 5.22731C5.86047 5.62818 5.63527 6.17186 5.63527 6.73877C5.63527 6.89338 5.69669 7.04165 5.80601 7.15098C5.91534 7.26031 6.06362 7.32173 6.21823 7.32173C6.37284 7.32173 6.52111 7.26031 6.63044 7.15098C6.73977 7.04165 6.80118 6.89338 6.80118 6.73877L6.80663 6.63927C6.83288 6.39215 6.95283 6.16448 7.1418 6.00308C7.33078 5.84169 7.57442 5.75884 7.82261 5.77159C8.0708 5.78433 8.30467 5.89169 8.47612 6.07159C8.64758 6.25149 8.74358 6.49025 8.74438 6.73877C8.74438 7.1927 8.62157 7.3979 8.1381 7.88137L8.00674 8.01428C7.42068 8.62444 7.18982 9.06283 7.18982 9.84788C7.18982 10.0025 7.25124 10.1508 7.36057 10.2601C7.46989 10.3694 7.61817 10.4308 7.77278 10.4308C7.92739 10.4308 8.07567 10.3694 8.185 10.2601C8.29432 10.1508 8.35574 10.0025 8.35574 9.84788C8.35574 9.39395 8.47855 9.18875 8.96202 8.70528L9.09338 8.57237C9.67945 7.9622 9.9103 7.52382 9.9103 6.73877C9.9103 6.17186 9.6851 5.62818 9.28423 5.22731Z",
    })
  );
};

const ForwardRef = React.forwardRef(QuestionMarkIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
